import { useEffect, useState, useRef } from 'react'
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Login.css"
import {
	SetLocal,
	ClearLocal,
	FetchService,
	IsValidNationalCode,
	IsEmptyString,
	IsEmptyInput,
	GetLocal
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import SelectControl from '../../../Controls/SelectControl';

export default function Index({ Click, page }) {
	const textBoxUserNameRef = useRef(null);
	const textBoxPasswordRef = useRef(null);

	const textLicenceNumberRef = useRef(null);
	const textBoxSMSCodeRef = useRef(null);
	const textBoxNewPasswordRef = useRef(null);
	const textBoxNewPasswordRepeatRef = useRef(null);
	const [licenseNumber, setLicenseNumber] = useState("");

	const inputSelectRef = useRef(null);
	const [getSelectData, setSelectData] = useState([]);
	const [comboRegionDisabled, setComboRegionDisabled] = useState(true);
	const [showLoginPage, setShowLoginPage] = useState(true);
	const [isConnectionAttrributeCalled, setIsConnectionAttrributeCalled] = useState(false);
	const [regionCodeState, setRegionCodeState] = useState(0);
	const navigate = useNavigate();
	//const [nationalCode, checkNationalCode] = useState(true);

	useEffect(() => {

		if (!showLoginPage) {
			if (textBoxSMSCodeRef.current) {
				textBoxSMSCodeRef.current.value = ""
			}
			if (textBoxNewPasswordRef.current) {
				textBoxNewPasswordRef.current.value = ""
			}
			return
		};
		const captchaInput = document.getElementById('user_captcha_input');
		if (!captchaInput) return;
		loadCaptchaEnginge(5, 'white', 'black', 'numbers');
		const reloadElement = document.querySelector('#reload_href');
		if (reloadElement) {
			reloadElement.innerHTML = "کد امنیتی مجدد";
			reloadElement.classList.add('refresh');
		}
		const handleKeyDown = (event) => {
			if (event.keyCode === 13) {
				let user_captcha = captchaInput.value;
				if (validateCaptcha(user_captcha) === true) {
					LoginSubmit();
				}
			}
		};

		captchaInput.addEventListener('keydown', handleKeyDown);

		return () => {
			captchaInput.removeEventListener('keydown', handleKeyDown);
		};


	}, [showLoginPage]);



	useEffect(() => {
		var inputValue = {};
		FetchService("General/IsMultiRegion", inputValue, IsMultiRegionSuccess, IsMultiRegionFail);


	}, []);
	const IsMultiRegionSuccess = (ServiceResult) => {
		var inputValue = {};
		FetchService("General/Abstract/BasicInfo/ShowRegionAbstractList", inputValue, ShowRegionAbstractListSuccess);
	}
	const IsMultiRegionFail = (ServiceResult) => {
		setComboRegionDisabled(true)
	}

	const ShowRegionAbstractListSuccess = (ServiceResult) => {
		setSelectData(ServiceResult.RegionInfo);
		setComboRegionDisabled(false)

	}

	const GetConnetionAttribute = () => {
		let input = {
			regionCode: inputSelectRef.current?.value || 0,
		}
		FetchService("General/GetConnectionAttribute", input, GetConnetionAttributeSuccess)
	}
	const GetConnetionAttributeSuccess = (ServiceResult) => {
		if (ServiceResult) {
			setIsConnectionAttrributeCalled(true)
		}
	}
	const LoginRequest = () => {

		if (!validateLoginForm(false)) return
		setRegionCodeState(Number(inputSelectRef.current?.value) || 0)
		var inputValue = {
			licenseNumber: textBoxUserNameRef.current.value,
			regionID: Number(inputSelectRef.current?.value) || 0
		};
		FetchService("Engineer/Security/LoginRequest", inputValue, LoginRequestSuccess, LoginRequestFail);




	}
	const LoginRequestSuccess = (ServiceResult) => {
		setShowLoginPage(false)
	}
	const LoginRequestFail = (error) => {
		toast.error(error)
	}

	const validateLoginForm = (needsPassword) => {
		if (IsEmptyInput(textBoxUserNameRef)) {
			toast.error('لطفا شماره پروانه را وارد نمایید');
			return false;
		}

		if (needsPassword && IsEmptyInput(textBoxPasswordRef)) {
			toast.error('لطفا رمز عبور را وارد نمایید');
			return false;
		}

		if (!comboRegionDisabled && (!isConnectionAttrributeCalled || !inputSelectRef.current?.value)) {
			toast.error('لطفا منطقه را انتخاب نمایید');
			return false
		}

		let user_captcha = document.getElementById('user_captcha_input').value;
		if (needsPassword && validateCaptcha(user_captcha) !== true) {
			document.getElementById('user_captcha_input').style.border = "1px solid #ff0000cc"
			toast.error('لطفا کد امنیتی را وارد نمایید');
			return false;
		}
		return true;
	}

	const LoginSubmit = () => {

		if (!validateLoginForm(true)) return
		var inputValue = {
			licenseNumber: textBoxUserNameRef.current.value,
			password: textBoxPasswordRef.current.value,
			regionID: Number(inputSelectRef.current?.value) || 0
		};
		FetchService("Engineer/Security/Login", inputValue, LoginSuccess);
	}

	const LoginSuccess = (ServiceResult) => {
		localStorage.clear();
		SetLocal('EngineerSession', ServiceResult.sessionInfo.SessionValue);
		SetLocal('FullName', ServiceResult.userInfo.FullName);
		navigate(`/Engineer/GetEngineerFileList?page=نمایش لیست پرونده ها`);
	}

	const LoginFinalizing = () => {
		if (!textBoxNewPasswordRef.current.value) {
			toast.error("رمز عبور را به درستی وارد کنید")
			return
		}
		if (!textBoxNewPasswordRepeatRef.current.value) {
			toast.error("تکرار رمز عبور را به درستی وارد کنید")
			return
		}
		if (!textBoxSMSCodeRef.current.value) {
			toast.error("کد رهگیری را به درستی وارد کنید")
			return
		}
		if (!textLicenceNumberRef.current.value) {
			toast.error("شماره پروانه را به درستی وارد کنید")
			return
		}
		if (textBoxNewPasswordRepeatRef.current.value !== textBoxNewPasswordRef.current.value) {
			toast.error("رمز عبور و تکرار آن باید برابر باشند")
			return
		}

		var inputValue = {
			regionID: regionCodeState || 0,
			identifier: licenseNumber,
			tokenCode: textBoxSMSCodeRef.current.value,
			password: textBoxNewPasswordRef.current.value,
			confirmPassword: textBoxNewPasswordRepeatRef.current.value,

		};
		FetchService("Engineer/Security/LoginFinalizing", inputValue, LoginFinalizingSuccess, LoginFinalizingFail)
	}
	const LoginFinalizingSuccess = (ServiceResult) => {
		backToLogin()
	}
	const LoginFinalizingFail = (error) => {
		toast.error(error)
	}

	const backToLogin = () => {
		setShowLoginPage(true);
	};

	return (
		<div id="bglogin">
			<div className="main ">
				{showLoginPage ?
					<div className="formLogin">
						<div>
							<div className='my-3'>
								<SelectControl
									data={getSelectData}
									inputRef={inputSelectRef}
									title={"منطقه:"}
									required={!comboRegionDisabled}
									disabled={comboRegionDisabled}
									onChange={() => GetConnetionAttribute()}
								/>
							</div>
							<TextBoxControl
								inputRef={textBoxUserNameRef}
								title="شماره پروانه:"
								required={true}
								placeholder="شماره پروانه خود را وارد نمایید"
								onlyNumbers={true}
								value={licenseNumber}
								onChange={(value) => setLicenseNumber(value)}
							/>

							<TextBoxControl
								inputRef={textBoxPasswordRef}
								type="password"
								title="رمز عبور:"
								required={true}
								placeholder="رمز عبور خود را وارد نمایید"
							/>

							<div className="d-flex  mb-2">
								<div><input id="user_captcha_input" placeholder="کد امنیتی" maxlength="5" className="form-control" name="user_captcha_input" type="text"></input></div>
								<LoadCanvasTemplate />
							</div>

							<ButtonControl
								onClick={LoginSubmit}
								variant="primary "
								title="ورود"
							/>

							<ButtonControl
								onClick={() => navigate("/")}
								variant="danger mx-2"
								title="بازگشت"
							/>

							<ButtonControl
								onClick={LoginRequest}
								variant="success text-white"
								title="درخواست رمز عبور"
							/>

						</div>
					</div> :
					<div className="formLogin LoginRequest">
						<div>

							<TextBoxControl
								inputRef={textLicenceNumberRef}
								title="شماره پروانه:"
								onlyNumbers={true}
								required={true}
								placeholder="شماره پروانه خود را وارد نمایید"
								disabled={true}
								value={licenseNumber}
								onChange={(value) => setLicenseNumber(value)}
							/>
							<TextBoxControl
								inputRef={textBoxSMSCodeRef}
								title="کد رهگیری:"
								onlyNumbers={true}
								required={true}
								placeholder="کد رهگیری پیامک شده را وارد نمایید"
								hideAutoComplete={true}
							/>

							<TextBoxControl
								inputRef={textBoxNewPasswordRef}
								type="password"
								title="رمز عبور:"
								required={true}
								placeholder="رمز عبور جدید خود را وارد نمایید"
							/>
							<TextBoxControl
								inputRef={textBoxNewPasswordRepeatRef}
								type="password"
								title="رمز عبور:"
								required={true}
								placeholder="تکرار رمز عبور جدید خود را وارد نمایید"
							/>



							<ButtonControl
								onClick={LoginFinalizing}
								variant="success"
								title="ذخیره"
							/>

							<ButtonControl
								onClick={backToLogin}
								variant="danger mx-2"
								title="انصراف"
							/>



						</div>
					</div>
				}
			</div>
		</div>
	);
}